module.exports = __webpack_public_path__ + "static/media/xiaojun-8.jpeg";